'use client'

import { useState } from 'react'
import { useTranslation } from '@/i18n/client'

export function TranslationNotice() {
  const { locale, t } = useTranslation()
  const [open, setOpen] = useState(false)

  // Nicht anzeigen bei deutscher Sprache (Originalsprache)
  if (locale === 'de') return null

  const notice = t('common.translationNotice')
  if (!notice || notice === 'common.translationNotice') return null

  const labelKey = t('common.translationLabel')
  const label = labelKey === 'common.translationLabel' ? 'Translation' : labelKey

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 max-w-[320px]">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-[10px] font-bold text-[var(--muted)] hover:text-[var(--text)] transition-colors bg-[var(--bg-card)] border border-[var(--border)] rounded-lg px-2.5 py-1.5 shadow-sm cursor-pointer"
      >
        <span>🌐</span>
        <span>{open ? '▼' : '▶'} {label}</span>
      </button>
      {open && (
        <div className="mt-1 p-3 rounded-xl border border-[var(--border)] bg-[var(--bg-card)] shadow-lg text-[11px] text-[var(--muted)] leading-relaxed">
          {notice}
        </div>
      )}
    </div>
  )
}
